/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Invitations_Reminders_Over_PartnersInputs */

const en_queue_invitations_reminders_over_partners = /** @type {(inputs: Queue_Invitations_Reminders_Over_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand and supplier invitations not accepted after the reminders`)
};

/**
* | output |
* | --- |
* | "Brand and supplier invitations not accepted after the reminders" |
*
* @param {Queue_Invitations_Reminders_Over_PartnersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_invitations_reminders_over_partners = /** @type {((inputs?: Queue_Invitations_Reminders_Over_PartnersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Invitations_Reminders_Over_PartnersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_invitations_reminders_over_partners(inputs)
});